import { render, staticRenderFns } from "./StickyDriverData.vue?vue&type=template&id=89b3da82&"
import script from "./StickyDriverData.vue?vue&type=script&lang=js&"
export * from "./StickyDriverData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports